import React from 'react';
import PropTypes from 'prop-types';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';

import FormAccordion from '@bo-components/common/form/FormAccordion';
import FormField from '@bo-components/common/form/FormField';
import Form from '@bo-components/common/form/Form';
import InfoTextBox from '@bo-components/promotion/InfoTextBox';
import { ReactComponent as Refresh } from '@bo-assets/icon/common/icon__form-refresh.svg';

const DetailDisplayInfo = ({ siteDisplay, handleRefreshClick }) => {
  const DisplayRefresh = () => (
    <Button width={'fit-content'} onClick={handleRefreshClick}>
      <Refresh />
    </Button>
  );

  const moveTo = (url) => {
    window.open(url);
  };

  return (
    <FormAccordion label={'전시관리'} initialOpen buttonless noFold customControl={DisplayRefresh()}>
      <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
        <Form>
          <FormField label={'메인템플릿'} full>
            <FlexBox justify-content={'space-between'} width={'100%'}>
              <TextBox>{siteDisplay.hasMainTemplate ? '등록완료' : '등록전'}</TextBox>
              <Button type={'Third'} move onClick={() => moveTo('/display/main-template/management')}>
                메인관리
              </Button>
            </FlexBox>
          </FormField>
          <FormField label={'전시카테고리'} full>
            <FlexBox justify-content={'space-between'} width={'100%'}>
              <TextBox>{siteDisplay.hasDisplayTemplate ? '등록완료' : '등록전'}</TextBox>
              <Button
                type={'Third'}
                move
                width={'140px'}
                onClick={() => moveTo('/display/display-category-template/management')}
              >
                전시카테고리관리
              </Button>
            </FlexBox>
          </FormField>
        </Form>
        <Spacing top={14} />
        <InfoTextBox>
          메인템플릿과 전시카테고리가 등록 완료되어야 사이트이동이 가능합니다.
        </InfoTextBox>
      </FlexBoxColumn>
    </FormAccordion>
  );
};

export default DetailDisplayInfo;

DetailDisplayInfo.propTypes = {
  siteDisplay: PropTypes.object,
  handleRefreshClick: PropTypes.func,
};
